import config from './package.json';
import LuckydrawSaga from './sagas/luckydrawSaga';
import { ModuleConfig } from '../../types/configTypes';

export default {
  config,
  sagas: [LuckydrawSaga],
} as ModuleConfig;
